/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseAgreed } from '../models/ApiResponseAgreed';
import type { ApiResponseListTermsCode } from '../models/ApiResponseListTermsCode';
import type { ApiResponseTermsConsentStatus } from '../models/ApiResponseTermsConsentStatus';
import type { ApiResponseVehicleInfo } from '../models/ApiResponseVehicleInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class VehicleService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 선택약관 지원목록 조회
   * 선택약관 지원목록 조회
   * @returns ApiResponseListTermsCode OK
   * @throws ApiError
   */
  public supportedSelectiveTermsCode({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListTermsCode> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicle/{vin}/terms/selective',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 선택약관 동의
   * 선택약관 동의
   * @returns ApiResponseAgreed OK
   * @throws ApiError
   */
  public consentSelectiveTermsCode({
    vin,
    termscode,
    agree,
  }: {
    vin: string,
    termscode: 'DI' | 'SAFETY_SCORE' | 'UBI',
    agree: boolean,
  }): CancelablePromise<ApiResponseAgreed> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/vehicle/{vin}/terms/selective',
      path: {
        'vin': vin,
      },
      query: {
        'termscode': termscode,
        'agree': agree,
      },
    });
  }
  /**
   * 약관 동의여부 확인
   * 약관 동의여부 확인
   * @returns ApiResponseTermsConsentStatus OK
   * @throws ApiError
   */
  public getConsentedSelectiveTermsCode({
    vin,
    termscode,
  }: {
    vin: string,
    termscode: 'DI' | 'SAFETY_SCORE' | 'UBI',
  }): CancelablePromise<ApiResponseTermsConsentStatus> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicle/{vin}/terms/{termscode}',
      path: {
        'vin': vin,
        'termscode': termscode,
      },
    });
  }
  /**
   * 차량정보 조회
   * 차량정보 조회
   * @returns ApiResponseVehicleInfo OK
   * @throws ApiError
   */
  public getVehicleInfo({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseVehicleInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicle/{vin}',
      path: {
        'vin': vin,
      },
    });
  }
}
